// The landing page's own behaviour (client/index.html #overlay, APP_STARTUP
// §7): the EN | DE toggle, the static translations, the "Recommended" tag
// on one device card and the video frame. main.js keeps everything that
// needs the connection (the cards' enable / devOff, roster, GPS, voice).
import { applyI18n, lang, setLang, onLang } from './i18n.js';
import './i18n/landing.js';

// THE landing video — the owner sets it: null = the "coming soon" frame;
// { youtube: '<11-char id>' } = youtube-nocookie.com, loaded only on click;
// { src: '<file>', poster: '<img>' } = a <video controls preload="none">.
export const LANDING_VIDEO = null;
const VIDEO_POSTER = 'photos/corviglia_view.jpg';

let _set = false;
export function setupLanding() {
  if (_set) return;
  _set = true;
  applyI18n(document);
  const tg = document.getElementById('lang-toggle');
  if (tg) {
    const sync = () => {
      for (const b of tg.querySelectorAll('button[data-lang]')) b.setAttribute('aria-pressed', String(b.dataset.lang === lang()));
    };
    tg.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-lang]');
      if (b) setLang(b.dataset.lang);
    });
    onLang(sync);
    sync();
  }
  buildVideo(document.getElementById('land-video'), LANDING_VIDEO);
  // a tile's detail opens on hover / focus (CSS); a tap on an open tile closes it
  for (const tile of document.querySelectorAll('#overlay .tile')) {
    tile.addEventListener('pointerdown', () => {
      if (document.activeElement === tile) setTimeout(() => tile.blur(), 0);
    });
  }
}

// one card is the device's best start (main.js picks it with the existing
// detection); its tag is a data-i18n span, so the language toggle keeps it
export function recommend(id) {
  for (const b of document.querySelectorAll('#overlay .dev.rec')) {
    b.classList.remove('rec');
    const old = b.querySelector('.dev-rec');
    if (old) old.remove();
  }
  const btn = document.getElementById(id);
  if (!btn || btn.classList.contains('off')) return;
  btn.classList.add('rec');
  const tag = document.createElement('span');
  tag.className = 'dev-rec';
  tag.dataset.i18n = 'land.rec';
  btn.prepend(tag);
  applyI18n(btn);
}

function buildVideo(box, v) {
  if (!box) return;
  box.textContent = '';
  if (v && typeof v.src === 'string') {
    const vid = document.createElement('video');
    vid.controls = true;
    vid.preload = 'none';
    vid.playsInline = true;
    vid.poster = typeof v.poster === 'string' ? v.poster : VIDEO_POSTER;
    vid.src = v.src;
    box.appendChild(vid);
    return;
  }
  const yt = v && typeof v.youtube === 'string' && /^[\w-]{11}$/.test(v.youtube) ? v.youtube : null;
  const shot = document.createElement('img');
  shot.src = VIDEO_POSTER;
  shot.alt = '';
  shot.loading = 'lazy';
  box.appendChild(shot);
  const play = document.createElement(yt ? 'button' : 'div');
  play.className = 'vid-play';
  play.innerHTML = '<span class="vid-tri" aria-hidden="true">▶</span>';
  const cap = document.createElement('span');
  cap.className = 'vid-cap';
  cap.dataset.i18n = yt ? 'land.video.play' : 'land.video.soon';
  play.appendChild(cap);
  if (yt) {
    const note = document.createElement('span');
    note.className = 'vid-note';
    note.dataset.i18n = 'land.video.yt';
    play.appendChild(note);
    // nothing loads from YouTube before this click
    play.onclick = () => {
      const f = document.createElement('iframe');
      f.src = `https://www.youtube-nocookie.com/embed/${yt}?autoplay=1&rel=0`;
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      f.title = 'GEO-VR';
      box.textContent = '';
      box.appendChild(f);
    };
  } else box.classList.add('soon');
  box.appendChild(play);
  applyI18n(box);
}
